import React, { useState } from 'react';
import { IStation } from '../../../ts/interface/station.interface';
import { PaginationTable } from '../../../components/Redesing/table/pagination-table';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { getPricingString, history } from '../../../utils';
import useUrlState from '../../../hooks/use-url-state';
import { DEFAULT_ROWS_PER_PAGE } from '../../../constants';
import { ISortConfig } from '../../../ts/interface/components/redesing/table.interface';
import { IRate } from '../../../ts/interface/rental.interface';

function RatesLocationCard({ detailedStation }: { detailedStation: IStation }) {
  const { rates } = detailedStation;
  const [exportRateData, setExportRateData] = useState<boolean>(false);
  const [pageState, setPageState] = useUrlState({
    sizePerPage: DEFAULT_ROWS_PER_PAGE,
    pageNumber: 0,
    lastId: null as string | null,
    search: null as string | null,
    rate: 0,
    sortConfig: {
      key: 'name',
      direction: 'asc',
    } as ISortConfig,
  });

  return (
    <>
      <PaginationTable
        exportData={exportRateData}
        onExport={() => setExportRateData(false)}
        csvFileName={'Location_Rates.csv'}
        buttons={[
          {
            label: 'Export',
            onClick: () => setExportRateData(true),
            startIcon: <FileDownloadIcon />,
          },
        ]}
        items={rates || []}
        noDataText={'No rates for this location'}
        customKey={'gid'}
        onRowCLick={(gid: string) => history.push(`/billing/rates/${gid}`)}
        columns={[
          {
            id: 'name',
            label: 'Name',
            shouldExport: true,
          },
          {
            id: 'rate',
            label: 'Rate',
            shouldExport: true,
            format: (row: IRate) => getPricingString({ ...row, base: row.base_rate }),
          },
        ]}
        rowsPerPage={pageState.sizePerPage}
        page={pageState.pageNumber}
        onPageChange={(page, pageN: number) =>
          setPageState((prevState) => ({ ...prevState, pageNumber: pageN }))
        }
        onRowsPerPageChange={(rowsPerPage) =>
          setPageState((prevState) => ({
            ...prevState,
            sizePerPage: Number(rowsPerPage),
            pageNumber: 0,
          }))
        }
        searchText={pageState.search || ''}
        searchPlaceholder={'Search Rates'}
        handleSearch={(event) =>
          setPageState((prevState) => ({ ...prevState, search: event.target.value }))
        }
      />
    </>
  );
}

export default RatesLocationCard;
